import * as React from "react"
import {useAppSelector} from "@/lib/hooks";

const MOBILE_BREAKPOINT = 768
// V2: tablets use the mobile shell (floating bottom nav + expanded menu), so the
// shell switches at a wider breakpoint than component-level mobile layouts.
const MOBILE_SHELL_BREAKPOINT = 1024

function useIsBelow(breakpoint: number) {
    const initialIsMobile = useAppSelector(state => state.ui.isMobile);
    const [isMobile, setIsMobile] = React.useState<boolean | undefined>(initialIsMobile);

    React.useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
        const onChange = () => {
            setIsMobile(window.innerWidth < breakpoint)
        }
        mql.addEventListener("change", onChange)
        setIsMobile(window.innerWidth < breakpoint)
        return () => mql.removeEventListener("change", onChange)
    }, [breakpoint])

    return !!isMobile
}

export function useIsMobile() {
    return useIsBelow(MOBILE_BREAKPOINT)
}

/** Mobile vs desktop shell (VersionResolver). Phones and tablets get the mobile shell. */
export function useIsMobileShell() {
    return useIsBelow(MOBILE_SHELL_BREAKPOINT)
}
